import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendKingdomWallet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 176,
	height: 176,
	viewBox: "0 0 176 176",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter_send_kingdom_wallet)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 88,
				cy: 88,
				r: 63,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("svg", {
			x: 60,
			y: 56,
			width: 56,
			height: 64,
			viewBox: "0 0 35 39",
			preserveAspectRatio: "xMidYMid meet",
			fill: "none",
			...props,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M33.2158 29.005C32.7205 28.5121 32.1261 28.1177 31.4326 27.9205V17.8649H33.1167V15.2032H31.4326V13.1329H33.1167V10.4711H31.4326V8.89376H28.7579V10.4711H27.0737V13.1329H28.7579V15.2032H27.0737V17.8649H28.7579V21.7097H25.885C25.4887 19.3437 23.9037 17.4706 21.2289 16.0904C21.427 15.8933 21.8233 15.6961 22.7149 15.6961L24.1018 15.7947V8.89376H14.2943L13.8981 9.58385C13.6999 9.8796 13.4027 10.1754 12.9074 10.7669C11.2233 12.2456 10.2327 14.2173 10.1336 16.5833V16.6819C10.2327 17.8649 10.4308 19.048 10.9261 19.9352C10.6289 22.7942 9.14295 24.7658 6.46819 25.6531C5.67567 25.8503 4.98221 26.0474 4.38782 26.4418C3.2981 25.9489 3.09997 25.1602 3.09997 24.5687C3.09997 23.8786 3.2981 22.9913 5.18034 22.3998C7.5579 21.6111 8.84575 19.8366 8.74669 17.2734V15.4003C9.73734 14.5131 10.3317 13.5272 10.4308 12.3442C10.5299 10.964 9.8364 9.48526 8.35043 8.10508L7.65697 7.31641L6.76538 8.20367C5.2794 9.58385 4.58595 11.0626 4.58595 12.4428C4.68501 13.5272 5.2794 14.6117 6.27006 15.4989V17.372C6.27006 18.8508 5.77473 19.5409 4.48688 20.0338C1.21773 21.1182 0.524277 23.1885 0.524277 24.7659C0.524277 25.7517 0.920538 27.2305 2.20838 28.3149C1.21773 29.3993 0.722407 30.8781 0.623342 32.554V38.0747H16.9691V37.8776C16.9691 36.4974 15.8794 35.413 14.4925 35.413H11.8177C12.5112 33.9342 13.799 32.8498 15.5822 32.2583C16.9691 32.0611 18.1579 31.7653 19.2476 31.371V38.0747H25.2906V37.8776C25.2906 36.4974 24.2009 35.413 22.8139 35.413H21.9224V30.0894C22.0214 29.9908 22.1205 29.8922 22.2195 29.7937C24.2009 28.2163 25.3896 26.3432 25.6868 24.3715H28.5597V28.0191C27.8663 28.2163 27.2719 28.6106 26.7765 29.1036C25.885 29.9908 25.4887 30.9767 25.4887 32.1597C25.4887 33.3427 25.885 34.4271 26.7765 35.2158C27.2719 35.7087 27.8663 36.1031 28.5597 36.3002V38.2719H31.2345V36.3002C31.9279 36.1031 32.5223 35.7087 33.0177 35.2158C33.9092 34.3285 34.3055 33.3427 34.3055 32.1597C34.5036 30.8781 34.1074 29.8922 33.2158 29.005ZM31.8289 32.0611C31.8289 32.554 31.6307 32.9484 31.3335 33.2441C31.0364 33.5399 30.6401 33.737 30.1448 33.737C29.6494 33.737 29.2532 33.5399 28.956 33.2441C28.6588 32.9484 28.4607 32.4554 28.4607 32.0611C28.4607 31.5682 28.6588 31.1738 28.956 30.8781C29.2532 30.5823 29.6494 30.3852 30.1448 30.3852C30.6401 30.3852 31.0364 30.5823 31.3335 30.8781C31.7298 31.2724 31.8289 31.5682 31.8289 32.0611ZM22.7149 24.8644C21.9224 23.2871 20.3373 22.1041 17.6626 21.3154H17.4644C15.4831 20.9211 14.1953 20.231 13.5018 19.048C13.1056 18.3579 12.9074 17.5692 12.8084 16.6819C12.8084 15.8933 13.0065 15.3017 13.2046 14.7102C14.1953 16.6819 16.2756 17.7664 19.1485 18.1607C21.7242 19.2451 23.1111 20.6253 23.2102 22.4984C23.2102 22.6956 23.2102 22.8927 23.2102 23.0899C23.2102 23.8786 23.0121 24.5687 22.7149 25.2588C22.8139 25.0616 22.8139 24.963 22.7149 24.8644ZM3.49623 35.3144V32.554C3.5953 31.371 3.89249 30.3852 4.58595 29.6951C6.27006 29.8922 7.45884 30.4837 8.15229 31.371C8.94482 32.2583 9.24201 33.6384 9.14295 35.3144H3.49623ZM10.2327 29.6951C9.63827 29.005 8.94482 28.4135 8.15229 28.0191C9.73734 27.329 11.1243 26.3432 12.0158 25.0616C12.6102 24.2729 13.0065 23.3857 13.3037 22.3998C14.2943 23.0899 15.5822 23.5828 17.0682 23.8786C18.8513 24.4701 19.9411 25.1602 20.4364 26.0474C20.7336 26.5404 20.7336 27.2305 20.5354 27.9205C20.4364 28.0191 20.3373 28.0191 20.3373 28.1177L20.2382 28.2163C19.2476 28.8078 17.6626 29.3007 15.4831 29.5965H15.0869C13.6009 30.0894 12.313 30.8781 11.4214 31.7653C11.1243 30.9767 10.728 30.2866 10.2327 29.6951ZM19.842 13.823C19.3467 14.2173 18.9504 14.7102 18.6532 15.3017C17.6626 15.1046 16.87 14.7102 16.3747 14.3159C15.7803 13.823 15.4831 13.1329 15.285 12.2456C15.4831 12.0485 15.6812 11.7527 15.8794 11.5555H21.5261V13.1329C20.9317 13.2315 20.3373 13.5272 19.842 13.823ZM7.65697 10.5697L7.8551 10.7669C8.25136 11.3584 8.44949 11.8513 8.44949 12.3442C8.44949 12.7385 8.25136 13.1329 7.8551 13.5272L7.75603 13.6258L7.65697 13.5272C7.26071 13.1329 7.06258 12.7385 7.06258 12.3442C7.06258 11.8513 7.26071 11.3584 7.65697 10.7669V10.5697Z",
					fill: "#FF3131"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.4177 7.90789L24.7952 3.57017L22.5167 2.28857L20.8326 5.24611H17.2663L15.5822 2.28857L13.2046 3.57017L15.6812 7.90789H22.4177Z",
					fill: "#FF3131"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.0546 -2.81389e-05L17.3739 1.67346L19.0556 3.34601L20.7363 1.67252L19.0546 -2.81389e-05Z",
					fill: "#FF3131"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter_send_kingdom_wallet",
			x: 0,
			y: 0,
			width: 176,
			height: 176,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSendKingdomWallet;
